import React, { useContext, useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
// import NewDrops from "../components/NewDrops";
import {  useParams } from "react-router-dom";
import { ProductContext } from "../contexts/ProductContext";
// import ProductSlider from "../components/ProductSlider";
import ProductImage from "../components/productDetailPage/ProductImage";
import ProductTitle from "../components/productDetailPage/ProductTitle";
import ProductOffer from "../components/productDetailPage/ProductOffer";
import ProductSize from "../components/productDetailPage/ProductSize";
import CartPincodeBtn from "../components/productDetailPage/CartPincodeBtn";
import PayDescription from "../components/productDetailPage/PayDescription";
import PolicyReturn from "../components/productDetailPage/PolicyReturn";
import RelatedProduct from "../components/productDetailPage/RelatedProduct";

function ProductDetail() {
  const { products } = useContext(ProductContext);
  const { id } = useParams();
  const [product, setProduct] = useState();
  const [relatedProducts, setRelatedProduct] = useState(product);

  useEffect(() => {
    // let foundProduct = products.find((item) => item.id === id); //not working beacuse of string id
    // let foundProduct = products.find((item) => item.id === parseInt(id)); // working beacuse of  id num
    let foundProduct = products.find((item) => {
      const numericId = parseInt(item.id.substring(item.id.lastIndexOf("/") + 1));
      return numericId === parseInt(id);
  });
    if (foundProduct) {
      setProduct(foundProduct);
      // console.log(product)
    }
    if (foundProduct) {
      const titleWords = foundProduct.title.split(" ");
      const lastWord = titleWords[titleWords.length - 1].toLowerCase();
      let filterRelatedProduct = products.filter((product) =>
        product.title.toLowerCase().includes(lastWord)
      );
      setRelatedProduct(filterRelatedProduct);
    }
  }, [id,products]);

  return (
    <section id="product-detail">
      <Navbar />
      {product && (
        <div className="px-4 product-container">
          <div className="gap-4 grid grid-cols-1 md:grid-cols-2 container">
            <div className="w-full image-container">
              <ProductImage product={product} />
            </div>
            <div className="w-full font-secondaryFont detail-container">
              <ProductTitle product={product} />
              <ProductOffer />
              {/* <ProductSize product={product} /> */}
              <CartPincodeBtn product={product} />
              <PayDescription />
              <PolicyReturn />
            </div>
          </div>
          <div className="w-full container related-products-container">
            <RelatedProduct
              relatedProducts={relatedProducts}
              Heading="Related Articals"
            />
          </div>
        </div>
      )}
      <Footer />
    </section>
  );
}

export default ProductDetail;

/* old code

useEffect(() => {
    // let foundProduct = products.find((item) => item.id === id); //not working beacuse of string id
    let foundProduct = products.find((item) => item.id === parseInt(id)); // convert string to num
    if (foundProduct) {
      setProduct(foundProduct);
    }
    if (foundProduct) {
      const lowerCaseQuery = foundProduct.title.toLowerCase(); // Assuming you want to filter by title
      const filterRelatedProduct = products.filter(
        (product) => JSON.stringify(product)?.toLowerCase().includes(lowerCaseQuery)

      );
      console.log(filterRelatedProduct)

      setRelatedProduct(filterRelatedProduct);
    }
  }, [id,products]);



  // const product = {
  //   name: "City Breeze White Cargo Pant",
  //   price: 1599,
  //   image: [
  //     "assets/All-products/allproducts09.jpg",
  //     "assets/All-products/allproducts10.jpg",
  //   ],
  //   description:
  //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed commodo nisi et libero blandit lacinia.",
  //   details: {
  //     fabric: "100% Polyester",
  //     fit: "Regular Fit",
  //     size: "S, M, L, XL",
  //     modelHeight: "5 Feet 10 Inches",
  //   },
  //   category: "Shirts",
  //   color: "Brown",
  //   newArrival: false,
  //   bestSeller: false,
  //   trending: true,
  //   stars: 4.5,
  //   reviews: 20,
  //   tags: ["casual", "comfortable", "stylish"],
  // };

 <div className="relative image-container">
          <img className="w-full" src={`${product?.image[0]}`} alt={product.name} />
          <img
            className="top-0 left-0 absolute opacity-0 group-hover:opacity-100 w-full transition-opacity duration-300"
            src={`/${product?.image[1]}`}
            alt={product.name}
          />
        </div>
        <div className="font-secondaryFont detail-container">
          <div className="pt-4 text-center heading-container">
            <h1 className="px-6 text-3xl">{product.name}</h1>
            <p className="mt-4 mb-1 font-bold">Rs. {product.price}</p>
            <p className="font-primaryFont text-[11px] tracking-wider">
              (incl. of all taxes)
            </p>
          </div>
        </div>
        <div className="flex flex-col justify-start items-start gap-2 py-4 pt-6 border-b-[1px] font-primaryFont discount-container">
          <div className="flex justify-self-start items-start gap-4 discount-card">
            <div>
              <img
                src="//www.snitch.co.in/cdn/shop/files/offer_icon-1_20x.png?v=1615371278/"
                alt=""
              />
            </div>
            <div>
              <p className="text-[12px]">
                Get this for <b className="">Rs. 899</b>
                <br />
                Buy 2 &amp; Get Flat 10% Off! Code: <strong>BUY2</strong>
              </p>
            </div>
          </div>
          <div className="flex justify-self-start items-start gap-4 discount-card">
            <div>
              <img
                src="//www.snitch.co.in/cdn/shop/files/offer_icon-1_20x.png?v=1615371278/"
                alt=""
              />
            </div>
            <div>
              <p className="text-[12px]">
                Get this for <b className="">Rs. 799</b>
                <br />
                Buy 5 &amp; Get Flat 20% Off! Code:
                <strong> BUY5</strong>
              </p>
            </div>
          </div>
          <div className="flex justify-self-start items-start gap-4 discount-card">
            <div>
              <img
                src="//www.snitch.co.in/cdn/shop/files/offer_icon-1_20x.png?v=1615371278/"
                alt=""
              />
            </div>
            <div>
              <p className="text-[12px]">
                Get this for <b className="">Rs. 849</b>
                <br />
                Flat 15% Off on minimum purchase of 2699/- <br />
                Code: <strong> FLAT15</strong>
              </p>
            </div>
          </div>
          <div className="flex justify-self-start items-start gap-4 discount-card">
            <div>
              <img
                src="//www.snitch.co.in/cdn/shop/files/offer_icon-1_20x.png?v=1615371278/"
                alt=""
              />
            </div>
            <div>
              <p className="text-[12px]">
                Get this for <b className="">Rs. 799</b>
                <br />
                Flat 20% Off on minimum purchase of 3999/- <br />
                Code: <strong> FLAT20</strong>
              </p>
            </div>
          </div>
        </div>
        <div className="flex flex-col justify-center items-center gap-2 py-4 w-full size-container">
          <span className="font-secondaryFont tracking-widest">Size</span>
          <div className="flex justify-center items-center gap-2 capitalize size-btn-container">
  {product.details.size.split(', ').map((size, index) => (
    <button
      key={index}
      className="border-[1px] hover:bg-black focus:bg-black active:bg-black border-black rounded-lg w-10 h-10 text-primary text-sm hover:text-white focus:text-white active:text-white"
    >
      {size}
    </button>
  ))}
</div>

        </div>

        <div className="flex flex-col justify-center items-center gap-4 mt-4 cart-and-pincode-btn-container">
          <div className="flex flex-col justify-center items-center gap-2 w-full cart-btn-container">
            <button className="bg-black hover:bg-primary p-3 w-full font-primaryFont font-semibold text-[12px] text-white tracking-wider cartbtn">
              ADD TO CART
            </button>
            <button className="border-2 p-3 hover:border-black w-full font-primaryFont font-semibold text-[12px] text-primary hover:text-black tracking-wider">
              Add To Wishlist
            </button>
          </div>
          <div
            iv
            className="flex flex-col justify-center items-center shadow-md hover:shadow-lg mb-4 p-2 p-4 rounded-md w-full transform transition-transform hover:-translate-y-2 duration-500 cursor-pointer pincode-container"
          >
            <p className="font-primaryFont font-semibold text-sm">
              Estimated Delivery Date & COD Checker
            </p>
            <div className="flex justify-between items-center w-full font-primaryFont pin-input-container">
              <input
                type="text"
                className="border-[1px] shadow-none px-4 p-2 w-[80%] text-sm outline-none"
                placeholder="Enter your pincode"
              />
              <button className="bg-black hover:bg-primary p-2 rounded-r-md w-[20%] text-[12px] text-white uppercase tracking-wider cartbtn">
                Check
              </button>
            </div>
          </div>
        </div>
        <div className="pay-description-container">
          <div class="relative font-primaryFont cursor-pointer group">
            <div class="flex justify-between items-center border-y-[1px] bg-white px-4 py-2">
              <a class="lg:mx-4 py-2 font-medium text-base text-primary menu-hover">
                EMI / PAY IN 3 OFFERS
              </a>
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  class="w-6 h-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                  />
                </svg>
              </span>
            </div>

            <div class="group-hover:visible z-50 absolute flex flex-col justify-start items-start gap-2 bg-gray-100 shadow-xl px-4 py-4 w-full font-primaryFont text-gray-800 invisible">
              <p>
                or Pay ₹333 and rest later via <b>SnitchPay</b>
              </p>
              <p>or 3 monthly payments of ₹333 with snapMint </p>
              <p>UPI & Cards Accepted, Online approval in 2 minutes</p>
              <p>Or 3 interest free payments of ₹333 </p>
            </div>
          </div>
          <div class="relative font-primaryFont cursor-pointer group">
            <div class="flex justify-between items-center border-y-[1px] bg-white px-4 py-2">
              <a class="lg:mx-4 py-2 font-medium text-base text-primary menu-hover">
                DESCRIPTION
              </a>
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  class="w-6 h-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                  />
                </svg>
              </span>
            </div>

            <div class="group-hover:visible z-50 absolute flex flex-col justify-start items-start gap-2 bg-gray-100 shadow-xl p-4 w-full font-primaryFont text-gray-800 invisible">
              <p className="text-sm">
                Elegant Monotone Maroon Shirt provides a reliable, professional
                look and is designed to be comfortable while wearing. Its
                sophisticated form makes it suitable for a variety of occasions,
                from formal events to party gatherings.
              </p>
              <strong className="text-left">PRODUCT SPECIFICATION</strong>
              <ul className="px-6 py-2 w-full list-disc">
                <li className="">Full Sleeves</li>
                <li>Solid Pattern</li>
                <li>Spread Collar</li>
                <li>Curved Hem Design</li>
                <li>Spare Buttons Included</li>
              </ul>
              <p>
                <b>FABRIC</b>: 100% Cotton
              </p>
              <p>
                <b>FIT</b>: Slim Fit
              </p>
              <p>
                <b>SIZE</b>: Model is wearing a M size{" "}
              </p>
              <p>
                <b>Model Height</b>: 100% Cotton
              </p>
              <p>
                <b>WASH CARE</b>: Cold machine wash. For more details see the
                wash care label attached.
              </p>
              <b className="text-sm">
                Actual colour of the product may vary slightly due to
                photographic lighting sources or your device.
              </b>
            </div>
          </div>
        </div>
        <div className="policy-container tab-container">
          <div className="flex flex-col items-center p-3 w-full">
            <div className="flex justify-center w-full btn-container">
              {["marketed by", "return policy", "place return request"].map(
                (item, index) => (
                  <button
                    key={index}
                    onClick={() => handleTabClick(index)}
                    className={`tab-button ${
                      activeTab === index
                        ? "bg-neutral-400 text-black"
                        : "bg-gray-200"
                    } cursor-pointer font-medium text-xs  w-1/3 py-2 px-2 capitalize font-primaryFont ${
                      index === 0
                        ? "rounded-tl-lg"
                        : index === 2
                        ? "rounded-tr-lg"
                        : ""
                    }`}
                  >
                    {item}
                  </button>
                )
              )}
            </div>
            <div className="w-full">
              <div className="border-gray-300 p-4 border border-t-0 rounded-b-lg w-full font-primaryFont tab-content">
                <div
                  id="tab1-content"
                  className={`tab-pane ${activeTab === 0 ? "" : "hidden"}`}
                >
                  <p className="font-bold text-xs">Snitch Apparels Pvt. Ltd.</p>
                  <p className="text-xs">
                    No. 1/1, St. Johns Church Road, Bharathinagar, Bengaluru -
                    560005
                  </p>

                  <p className="mt-2 font-bold text-xs">Country of Origin:</p>
                  <p className="text-xs">India</p>
                </div>
                <div
                  id="tab2-content"
                  className={`tab-pane ${activeTab === 1 ? "" : "hidden"}`}
                >
                  <p className="text-xs leading-5">
                    We offer 7 days hassle-free returns. Return Policies may
                    vary based on products and promotions.
                    <br />
                    1) Refunds for Prepaid orders would directly be initiated to
                    source account and COD order will be refunded in the form of
                    COUPON CODE ONLY
                    <br />
                    2) Defective Products, Wrong Products or Damaged Products
                    issue should be raised within 24 hrs of delivery
                    <br />
                    3) All Orders wherein FREE Products included are not
                    eligible for Return
                    <br />
                    For more details on our Returns Policies, please{" "}
                    <a href="" className="font-bold">
                      click here
                    </a>
                    ․
                  </p>
                </div>
                <div
                  id="tab3-content"
                  className={`tab-pane ${activeTab === 2 ? "" : "hidden"}`}
                >
                  <p className="text-xs">
                    To place any Returns Request,{" "}
                    <a href="" className="font-bold">
                      click here
                    </a>
                    .
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="related-products-container">
          <div className="p-4 text-center heading">
            <h3 className="font-primaryFont text-2xl uppercase">
              Related Articals
            </h3>
          </div>
          <ProductSlider products={relatedProducts} howManyProductShowCss="w-1/3" />
        </div>
      </div>}

      */
